module.exports = __webpack_public_path__ + "b7acd796583d3b0eb1c89334c6761a94.svg";